import { button } from 'react-validation';
import { DrcButton } from '@driscollsinc/driscolls-react-components';

export default button(({ ...props }) => <DrcButton {...props} />);
